import React from 'react';
import { HoldingEntityIcon } from '../assets/icons';

// Main holding entity icon used in the existing HoldingEntityList components
export const HoldingEntitySvg = ({ width = 18, height = 18, color = "#1A1B1D", ...props }) => {
  return (
    <HoldingEntityIcon 
      width={width} 
      height={height} 
      style={{ color }} 
      {...props} 
    />
  );
};

// Generic entity icon function that returns the appropriate icon based on entity type
export const EntityIcon = ({ type, width = 18, height = 18, color = "#1A1B1D", ...props }) => {
  // For now, all entity types use the same holding entity icon
  // This can be expanded in the future to support different icons for different types
  return (
    <HoldingEntitySvg 
      width={width} 
      height={height} 
      color={color} 
      {...props} 
    />
  );
}; 